import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { User } from '../assets';
import { useRates } from '../code/Rates';

const Referral = () => {
  const { selectedCurrency, convertBalance } = useRates();
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchReferralData = async () => {
      try {
        const accessToken = localStorage.getItem('accessToken');
        if (!accessToken) {
          setError('No access token found.');
          setLoading(false);
          return;
        }

        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/referrals`, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        });

        setUsers(response.data);
        setLoading(false);
      } catch (err) {
        setError('Error fetching referral data.');
        setLoading(false);
        console.error(err);
      }
    };

    fetchReferralData();
  }, []);

  if (loading) {
    return (
      <div className="flex w-full flex-col gap-2 p-2">
        <div className="font-bold my-1 text-[18px] text-center">Referral</div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-2 w-full overflow-y-auto">
          {Array(6).fill(0).map((_, index) => (
            <div key={index} className="flex flex-col w-full p-2 gap-1 min-h-[60px] h-fit bg-slate-100 animate-pulse rounded-[12px]">
              <div className="flex w-full items-center gap-4 flex-shrink-0">
                <div className="h-[50px] w-[50px] bg-gray-300 rounded-full"></div>
                <div className="flex flex-col w-full leading-[1.1]">
                  <div className="h-[14px] bg-gray-300 rounded w-[70%]"></div>
                  <div className="h-[12px] bg-gray-300 rounded w-[50%] mt-1"></div>
                  <div className="h-[12px] bg-gray-300 rounded w-[40%] mt-1"></div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  if (error) {
    return <div>{error}</div>;
  }

  return (
    <div className="flex w-full flex-col gap-2 p-2">
      <div className="font-bold my-1 text-[18px] text-center">Referral</div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-2 w-full overflow-y-auto">
        {users.length > 0 ? (
          users.map((user) => (
            <div key={user.id} className="flex flex-col w-full p-2 gap-1 min-h-[60px] h-fit bg-slate-100 hover:bg-slate-200 rounded-[12px]">
              <div className="flex w-full items-center gap-4 flex-shrink-0">
                <img src={User} alt="Referred user" className="h-[50px] w-[50px] flex object-cover shrink-0 rounded-full" />
                <div className="flex flex-col w-full leading-[1.1]">
                  <div className="text-[14px] font-bold line-clamp-1">{user.username}</div>
                  <div className="flex text-[12px]">{user.referredId}</div>
                  <div className="text-[12px] text-gray-400 w-fit">{selectedCurrency} {convertBalance(user.referral_earn)}</div>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="text-center">No one has used your referral code. Share it!</div>
        )}
      </div>
    </div>
  );
};

export default Referral;
